module.exports = __webpack_public_path__ + "static/media/sel_01_227c.a691202c.mp4";